import { I18n } from 'aws-amplify/utils';

type MapEntry = [string, RegExp, string?];

export const MapEntries: MapEntry[] = [
  ['User does not exist', /user.*not.*exist/i],
  ['User is disabled.', /user.*is.*disabled/i],
  ['User is not confirmed.', /user.*is.*not.*confirmed/i],
  ['User already exists', /user.*already.*exist/i],
  ['Incorrect username or password', /incorrect.*username.*password/i],
  ['An account with the given email already exists.', /account.*email.*already.*exist/i],
  ['Password attempts exceeded', /password.*attempts.*exceeded/i],
  ['Invalid password format', /validation.*password/i],
  ['Password not long enough', /password.*not.*long/i],
  [
    'Invalid phone number format',
    /invalid.*phone/i,
    'Invalid phone number format. Please use a phone number format of +12345678900',
  ],
];

export default (message: string) => {
  const match = MapEntries.filter((entry) => entry[1].test(message));
  if (match.length === 0) {
    return message;
  }

  const entry = match[0];
  const msg = entry.length > 2 ? entry[2] : entry[0];

  return I18n.get(entry[0], msg);
};
